"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModalSize = exports.SimpleModalSizing = void 0;
var SimpleModalSizing;
(function (SimpleModalSizing) {
    SimpleModalSizing["NORMAL"] = "normal";
    SimpleModalSizing["FULL"] = "full";
})(SimpleModalSizing = exports.SimpleModalSizing || (exports.SimpleModalSizing = {}));
var SimpleModalSize;
(function (SimpleModalSize) {
    SimpleModalSize["SMALL"] = "small";
    SimpleModalSize["MEDIUM"] = "medium";
    SimpleModalSize["LARGE"] = "large";
    SimpleModalSize["EXTRA_LARGE"] = "extralarge";
    SimpleModalSize["SHEET"] = "sheet";
    SimpleModalSize["FULL_SCREEN"] = "fullscreen";
})(SimpleModalSize = exports.SimpleModalSize || (exports.SimpleModalSize = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/SimpleModal/SimpleModalProps.js
// module id = 241
// module chunks = 8